import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from 'vuetify/lib/locale/en'
import fr from 'vuetify/lib/locale/fr'

Vue.use(VueI18n)

const messages = {
  en: {
    ...require('@/locales/en.json'),
    $vuetify: en
  },
  fr: {
    ...require('@/locales/fr.json'),
    $vuetify: fr
  }
}

function defaultLocale () {
  let lang = 'fr'
  // if (navigator.language) lang = navigator.language.split('-')[0]
  // if (navigator.userLanguage) lang = navigator.userLanguage.split('-')[0]
  return lang
}

export default new VueI18n({
  current: 'fr',
  locale: defaultLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'fr',
  messages
})
